const safelyProvideAutoCompletions = async _ref => {
  let {
    fullEditorText,
    language,
    provider,
    wordAtPosition
  } = _ref;
  try {
    const providedCompletions = await provider.provideCompletionItems({
      fullEditorText,
      language,
      wordAtPosition
    });
    return providedCompletions;
  } catch (error) {
    // If there's an error, there's not really a convenient way to communicate this to the user
    // So for now, we just silently fail
    return [];
  }
};
export default safelyProvideAutoCompletions;